var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5003 18.9583H7.50033C2.97533 18.9583 1.04199 17.025 1.04199 12.5V7.50001C1.04199 2.97501 2.97533 1.04167 7.50033 1.04167H11.667C12.0087 1.04167 12.292 1.32501 12.292 1.66667C12.292 2.00834 12.0087 2.29167 11.667 2.29167H7.50033C3.65866 2.29167 2.29199 3.65834 2.29199 7.50001V12.5C2.29199 16.3417 3.65866 17.7083 7.50033 17.7083H12.5003C16.342 17.7083 17.7087 16.3417 17.7087 12.5V8.33334C17.7087 7.99167 17.992 7.70834 18.3337 7.70834C18.6753 7.70834 18.9587 7.99167 18.9587 8.33334V12.5C18.9587 17.025 17.0253 18.9583 12.5003 18.9583Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3337 8.95833H15.0003C12.1503 8.95833 11.042 7.85 11.042 5V1.66666C11.042 1.41666 11.192 1.18333 11.4253 1.09166C11.6587 0.991662 11.9253 1.05 12.1087 1.225L18.7753 7.89166C18.9503 8.06666 19.0087 8.34166 18.9087 8.575C18.8087 8.80833 18.5837 8.95833 18.3337 8.95833ZM12.292 3.175V5C12.292 7.15 12.8503 7.70833 15.0003 7.70833H16.8253L12.292 3.175Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.833 11.4583H5.83301C5.49134 11.4583 5.20801 11.175 5.20801 10.8333C5.20801 10.4917 5.49134 10.2083 5.83301 10.2083H10.833C11.1747 10.2083 11.458 10.4917 11.458 10.8333C11.458 11.175 11.1747 11.4583 10.833 11.4583Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16634 14.7917H5.83301C5.49134 14.7917 5.20801 14.5083 5.20801 14.1667C5.20801 13.825 5.49134 13.5417 5.83301 13.5417H9.16634C9.50801 13.5417 9.79134 13.825 9.79134 14.1667C9.79134 14.5083 9.50801 14.7917 9.16634 14.7917Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrders);
export default __webpack_public_path__ + "static/media/orders.48a9da845454a77bc978c44f92bd29a2.svg";
export { ForwardRef as ReactComponent };